function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFactory = function SvgFactory(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prefix__Group_159",
    width: 24,
    height: 24,
    "data-name": "Group 159",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_15",
    d: "M0 0h24v24H0z",
    "data-name": "Path 15",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_16",
    d: "M17.364 16.091H19v1.636H1v-1.636h1.636V3.818A.818.818 0 0 1 3.455 3h8.182a.818.818 0 0 1 .818.818v12.273h3.273V9.545h-1.637V7.909h2.455a.818.818 0 0 1 .818.818zM4.273 4.636v11.455h6.545V4.636zm1.636 4.909h3.273v1.636H5.909zm0-3.273h3.273v1.637H5.909z",
    "data-name": "Path 16",
    transform: "translate(2 2)",
    style: {
      fill: "#8e44ad"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFactory, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/factory.45692234.svg";
export { ForwardRef as ReactComponent };